/**
 * Splits the search text into parts based on non-alphanumeric characters,
 *
 * @param searchText - The search text to split into searchable parts
 * @returns string[]
 */
export const getSearchTextParts = (searchText: string): string[] => {
  // Use a regular expression to match non-alphanumeric characters
  // except for underscores (_), hyphens (-), and spaces ( )
  const regex = /[^a-zA-Z0-9_ -]+/g;

  // Split the searchText by the non-alphanumeric characters and filter out empty parts
  const parts = searchText
    .split(regex)
    .filter((part) => part.trim() !== "" && part.trim().length > 2);

  return parts;
};
